__turbopack_context__.v({
  "negativeGap": "XStack-module__TyZetG__negativeGap",
  "xStack": "XStack-module__TyZetG__xStack",
});
